import {useControllerProps} from '../../../../Widget/ControllerContext';
import {useMemberDetailsData} from '../../../../MemberDetails/WithMemberDetailsData';
import {useEffect, useState} from 'react';
import {StatesButtonStates} from 'wix-ui-tpa/cssVars';
import {ADD_NEW_ADDRESS_ID} from '../../../../constants';

export function useContinueButtonState() {
  const {
    checkoutStore: {updateCheckoutError},
    formsStore: {areFormsLoaded},
  } = useControllerProps();

  const {editMode, areMemberDetailsValid, selectedAddressesServiceId} = useMemberDetailsData();

  const [continueButtonState, setContinueButtonState] = useState(StatesButtonStates.IDLE);

  const [isContinueButtonDisabled, setIsContinueButtonDisabled] = useState(!areFormsLoaded);

  useEffect(() => {
    if (updateCheckoutError) {
      setContinueButtonState(StatesButtonStates.IDLE);
      setIsContinueButtonDisabled(false);
    }
  }, [updateCheckoutError]);

  useEffect(() => {
    const disableContinueButton =
      !areFormsLoaded || (!areMemberDetailsValid && !editMode && selectedAddressesServiceId !== ADD_NEW_ADDRESS_ID);
    setIsContinueButtonDisabled(disableContinueButton);
  }, [areFormsLoaded, areMemberDetailsValid, editMode, selectedAddressesServiceId]);

  return {continueButtonState, isContinueButtonDisabled, setContinueButtonState, setIsContinueButtonDisabled};
}
